"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var websocket_1 = require("../../transport/websocket");
var xhr_1 = require("../../transport/xhr");
var transports_manager_1 = require("../../transport/transports-manager");
var strategy_presets_1 = require("../../strategies/strategy-presets");
function transports(opts) {
    if (websocket_1.default.isSupported()) {
        var xhr_2 = anXhrAsFallback(opts.baseUrl);
        var ws = aWebSocket(opts.baseUrl);
        return new transports_manager_1.default([ws, xhr_2]);
    }
    var xhr = anXhrAsPrimary(opts.baseUrl);
    return new transports_manager_1.default([xhr]);
}
exports.default = transports;
function aWebSocket(baseUrl) {
    var protocol = isSSL() ? 'wss://' : 'ws://';
    var url = "" + protocol + baseUrl;
    var ws = new websocket_1.default(url);
    return strategy_presets_1.aWebSocketStrategyPreset1(ws);
}
function anXhrAsFallback(baseUrl) {
    var xhr = anXhrTransport(baseUrl);
    return strategy_presets_1.anXhrStrategyPreset1(xhr);
}
function anXhrAsPrimary(baseUrl) {
    var xhr = anXhrTransport(baseUrl);
    return strategy_presets_1.anXhrStrategyPreset2(xhr);
}
function anXhrTransport(baseUrl) {
    var protocol = isSSL() ? 'https://' : 'http://';
    var url = "" + protocol + baseUrl;
    return new xhr_1.default(url);
}
function isSSL() {
    return typeof self !== 'undefined' && self.location.protocol !== 'http:';
}
//# sourceMappingURL=transports.js.map